import { createContext, useEffect, useReducer, useContext } from "react";
import { LiferayService } from "../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";
import { getPathName } from "../../../common/utils/utilsFunc";


export const BusquedaClienteContext = createContext();
export const ACTIONS = {
    SET_COMUNA: "SET_COMUNA",
    SET_CODIGO_CIUDAD: "SET_CODIGO_CIUDAD",
    SET_CALLES: "SET_CALLES",
    SET_COMUNA_ID: "SET_COMUNA_ID",
    SET_BODY_CLIENTE_DIRECCION: "SET_BODY_CLIENTE_DIRECCION",
    SET_BODY_CLIENTE_MEDIDOR: "SET_BODY_CLIENTE_MEDIDOR",
    SET_RESPONSE_DIRECCION: "SET_RESPONSE_DIRECCION",
    SET_RESPONSE_MEDIDOR: "SET_RESPONSE_MEDIDOR",
};

const initialState = {
    comuna: {},
    codigo_ciudad: [],
    calles: null,
    comuna_id: [],
    bodyClienteDireccion: [],
    bodyClienteMedidor: [],
    responseDireccion: null,
    responseMedidor: null,

};
const BusquedaClienteReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTIONS.SET_COMUNA: {
            return {
                ...state,
                comuna: action.payload,
            };
        }
        case ACTIONS.SET_CODIGO_CIUDAD: {
            return {
                ...state,
                codigo_ciudad: action.payload,
            };
        }
        case ACTIONS.SET_CALLES: {
            return {
                ...state,
                calles: action.payload,
            };
        }
        case ACTIONS.SET_COMUNA_ID: {
            return {
                ...state,
                comuna_id: action.payload,
            };
        }
        case ACTIONS.SET_BODY_CLIENTE_DIRECCION: {
            return {
                ...state,
                bodyClienteDireccion: action.payload,
            };
        }
        case ACTIONS.SET_BODY_CLIENTE_MEDIDOR: {
            return {
                ...state,
                bodyClienteMedidor: action.payload,
            };
        }
        case ACTIONS.SET_RESPONSE_DIRECCION: {
            return {
                ...state,
                responseDireccion: action.payload,
            };
        }
        case ACTIONS.SET_RESPONSE_MEDIDOR: {
            return {
                ...state,
                responseMedidor: action.payload,
            };
        }
        default: {
            return state;
        }
    }
};
const BusquedaClienteContextProvider = ({ children }) => {
    const properties = useContext(ApplicationPropertiesContext);
    const [state, dispatch] = useReducer(BusquedaClienteReducer, initialState);

    useEffect(() => {
        if ( (getPathName() === 'busqueda-cliente' || getPathName() === 'para-estar-informados-completa-tus-datos') ) {
            LiferayService.getComuna(properties.base_url_api, properties.codigo_empresa)
                .then((response) => {
                    dispatch({
                        payload: response,
                        type: ACTIONS.SET_COMUNA,
                    });
                })
        }
    }, []);

    useEffect(() => {
        if ( (getPathName() === 'busqueda-cliente' || getPathName() === 'para-estar-informados-completa-tus-datos')  && state.comuna_id != "") {
            LiferayService.getCalles(properties.base_url_api, state.comuna_id)
                .then((response) => {
                    dispatch({
                        payload: response,
                        type: ACTIONS.SET_CALLES,
                    });
                })
        }
    }, [state.comuna_id]);

    useEffect(() => {
        if ( (getPathName() === 'busqueda-cliente' || getPathName() === 'para-estar-informados-completa-tus-datos')  && state.bodyClienteDireccion.length != 0) {
            LiferayService.getClienteDireccion(properties.base_url_api, properties.codigo_empresa, state.bodyClienteDireccion, state.codigo_ciudad, properties.url_ws_empresa)
                .then((response) => {
                    dispatch({
                        payload: response,
                        type: ACTIONS.SET_RESPONSE_DIRECCION,
                    });
                })
        }
    }, [state.bodyClienteDireccion]);

    useEffect(() => {
        if ( (getPathName() === 'busqueda-cliente' || getPathName() === 'para-estar-informados-completa-tus-datos' || getPathName() === 'estas-sin-luz')  && state.bodyClienteMedidor.length != 0) {
            LiferayService.getClienteMedidor(properties.base_url_api, properties.codigo_empresa, state.bodyClienteMedidor, properties.url_ws_empresa)
                .then((response) => {
                    dispatch({
                        payload: response,
                        type: ACTIONS.SET_RESPONSE_MEDIDOR,
                    });
                })
        }
    }, [state.bodyClienteMedidor]);

    return (
        <BusquedaClienteContext.Provider value={[state, dispatch]}>
            {children}
        </BusquedaClienteContext.Provider>
    );
};
export default BusquedaClienteContextProvider;